/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Country_Change_Official_WarningInputs */



/**
* | output |
* | --- |
* | "This person has an official role. Changing their country changes what data they can access. Only continue if you can reassign their role." |
*
* @param {User_Country_Change_Official_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_country_change_official_warning = /** @type {((inputs?: User_Country_Change_Official_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Country_Change_Official_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette personne a un rôle officiel. Changer son pays change les données auxquelles elle a accès. Continuez seulement si vous pouvez réattribuer son rôle.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta persona tiene un cargo oficial. Cambiar su país cambia los datos a los que tiene acceso. Continúa solo si puedes reasignar su cargo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Esta pessoa tem um cargo oficial. Mudar o país dela muda os dados a que ela tem acesso. Só continue se você puder reatribuir o cargo dela.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa persona ha un ruolo ufficiale. Cambiarne il paese cambia i dati a cui ha accesso. Continua solo se puoi riassegnarne il ruolo.")
	return /** @type {LocalizedString} */ ("This person has an official role. Changing their country changes what data they can access. Only continue if you can reassign their role.")
});